import { useControlledState } from "@react-stately/utils";

/**
 * Provides state management for a search field.
 */
export function useSearchFieldState(props) {
  let [value, setValue] = useControlledState($a9d4cb04630987986dd69a33031$var$toString(props.value), $a9d4cb04630987986dd69a33031$var$toString(props.defaultValue) || '', props.onChange);
  return {
    value,
    setValue
  };
}

function $a9d4cb04630987986dd69a33031$var$toString(val) {
  if (val == null) {
    return;
  }

  return val.toString();
}
//# sourceMappingURL=module.js.map
